import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { notification } from 'antd';
import Select from 'react-select';
import $ from 'jquery';
import DocumentMeta from 'react-document-meta';
import Header from '../Inc/Layout/Header.js';
import Footer from '../Inc/Layout/Footer.js';
import { message } from '../../_constants';
import CustomLinkedIN from '../Linkdin/CustomLinkedIN.js';
import { Button, Pagination, PaginationItem, PaginationLink, Modal, ModalHeader, ModalBody } from 'reactstrap';
import loadingImage from "../loadingImageRc.gif";
import { getAllSugeetionByField, uploadResumeFile, reqUestDeniedByCity, getAllCityByCountryAction, getAllCountryAction,getAllCityAction } from '../../actions/FindRecCompany';
import { getAllHome } from '../../actions/home';
import { sendResumeAction } from '../../actions/SendResume';
import { listCityCountryStateAction } from '../../actions/Admin/CountryCityAction'

let className = "";
let fieldsArr = [];
let peginationButton = [];
let carts = {};

class SearchResult extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fieldsList: [],
            code: '',
            fieldSelct: '',
            disabledButton: false,
            detailsModal: false,
            resumeSectionModel: false,
            listStatus: true,
            resUmeUpload: false,
            resumeNotSelect: false,
            sendResumeOption: true,
            signInSectionModel: false,
            requestServer: false,
            fileName: "",
            categoryId: "",
            emailId: "",
            reqObj: { search: "" },
            formData: {},
            citySeacrh: JSON.parse(localStorage.getItem('locationCity'))?JSON.parse(localStorage.getItem('locationCity')):{ "label": "All", value: "all" },
            detailsData: {},
            resumeSendFor: "",
            tags: [],
            list: [],
            suggestions: [],
            countryOption: [],
            cityOption: [],
            fieldOption: [],
            tagvalue: [],
            citySeacrhCordinate: JSON.parse(localStorage.getItem("coordinate")) ? JSON.parse(localStorage.getItem("coordinate")) :[],
            checkedValue: [],
            cityData: [],
            optionSelect: [],
            totalCount: 0,
            activeButton: 1,
            showRecords: "showAll",
            selectResumeType: "upload",
            userData: JSON.parse(localStorage.getItem('userData')),
            countrySelect: JSON.parse(localStorage.getItem('locationCountry'))
        };
        this.pagePrvBack = this.pagePrvBack.bind(this);
    }

    componentWillMount() {
        if(this.state.citySeacrh && this.state.citySeacrh.label && this.state.citySeacrh.value == "all"){
            this.setState ({
               citySeacrhCordinate : JSON.parse(localStorage.getItem("coordinate"))
            });
        }else{
            this.handleChangeSelect("citySeacrh",this.state.citySeacrh)            
        }

        const userData = JSON.parse(localStorage.getItem('userData'));
        if ((userData && userData.userType === "company") || (userData && userData.userType === "recruiter")) {
            this.props.history.push({
                pathname: "/dashboard-home",
                state: { reqObj: "" }
            });
        }
        if (localStorage.getItem('userLogin') === "true") {
            const userData = JSON.parse(localStorage.getItem('userData'))
            if (userData && userData.userType === "user") {
                this.setState({
                    sendResumeOption: false
                })
            }
        }

        let reqObj = {
            "limit": 10,
            "offset": 0,
            "specializations": [],
            "order": "name",
            "direction": "desc",
            "search": "",
            "status": ""
        }

        this.props.getAllHome(reqObj);
        const { location } = this.props;
        console.log("location.state",location)
        if (location.state !== undefined) {
            localStorage.setItem("reqObj",JSON.stringify(location.state.reqObj))
            this.setState({
                reqObj: location.state.reqObj
            })
        }
        let cuntryReqObj = {
            countryName: this.state.countrySelect,
        }
        //this.props.getAllCityByCountryAction(cuntryReqObj)
        //this.props.getAllCountryAction()
        this.props.getAllCityAction()
    }

    componentDidMount() {
        let _this =this;
        this.suggeStionPost(10, 0);
        setTimeout(function() {
            if (_this.state.listStatus) {
                _this.setState({
                    requestServer: true
                })
            }
        }, 3000);
    }

    suggeStionPost = (limit, page, tvalue) => {
        const { reqObj, tagvalue, citySeacrh, citySeacrhCordinate, showRecords , userData } = this.state;
        if (tvalue && tvalue.length > 0) {
            tagvalue.push(tvalue);
        }
        var specliZations = (tagvalue.length === 0) ? "all" : tagvalue;
        var searchCity = localStorage.getItem("defaultCity");
        if (citySeacrh.label !== "All") {
            searchCity = citySeacrh.label
        }
        var searchByCoridinate = JSON.parse(localStorage.getItem("coordinate"));
        if (citySeacrh.label !== "All") {
            searchByCoridinate = citySeacrhCordinate
        }
        let reqObjs = {
            "limit": limit,
            "offset": page,
            "order": "createdAt",
            "direction": "asc",
            "city": searchCity,
            "coordinates": searchByCoridinate,
            "search": reqObj && reqObj.search !== "all" ? reqObj.search : "",
            "userType": reqObj && reqObj.userType,
            "categoryId": reqObj && reqObj.fieldSelct,
            "specializations": specliZations,
        }
        if(showRecords === "last30Days"){
            reqObjs.day=30
            reqObjs.userId= userData._id
        }        
        if(showRecords === "neverContected"){
            reqObjs.userId= userData._id
        }
        this.setState({
            activeButton:(page+1),
            listStatus: true,
        })
         this.props.getAllSugeetionByField(reqObjs);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.city && nextProps.city !== "") {
            this.props.reqUestDeniedByCity();
            this.suggeStionPost(10, 0, this.state.tagvalue);
        }

        if (nextProps && nextProps.responseCityByCountry && nextProps.responseCityByCountry.statusCode === 200) {
            var cityData = nextProps.responseCityByCountry.cityData && nextProps.responseCityByCountry.cityData.data
            let cityArr = [];
            for (var z in cityData) {
                let obj = {};
                obj.label = cityData[z].cityName;
                obj.value = cityData[z]._id;
                cityArr.push(obj);
            }
            this.setState({
                cityOption: cityArr
            })
        }

        if (nextProps && nextProps.responseCountry && nextProps.responseCountry.statusCode === 200) {
            var countryData = nextProps.responseCountry.data && nextProps.responseCountry.data.data
            let countryArr = [];
            for (var x in countryData) {
                for (var y in countryData[x].countryName) {
                    countryData[x].countryName[y]
                    let obj = {};
                    obj.label = countryData[x].countryName[y].label;
                    obj.value = countryData[x].countryName[y].value;
                    countryArr.push(obj);
                }
            }
            this.setState({
                countryOption: countryArr
            })
        }
        if (nextProps && nextProps.allCitySuggetion && nextProps.allCitySuggetion.statusCode === 200) {

            var cityData = nextProps.allCitySuggetion.cityData && nextProps.allCitySuggetion.cityData.data
            let cityArr = [];
            for (var z in cityData) {
                let obj = {};
                obj.label = cityData[z].cityName;
                obj.value = cityData[z]._id;
                cityArr.push(obj);
            }

            this.setState({
                cityData:cityData,
                cityOption: cityArr
            })
        } 
       
        // if (nextProps && nextProps.responseCityByCountry && nextProps.responseCityByCountry.statusCode === 500) {
        //     this.setState({
        //         cityOption: [{ label: "No Data", value: "No Data" }]
        //     })
        // }
        if (nextProps && nextProps.allCitySuggetion && nextProps.allCitySuggetion.statusCode === 500) {
            this.setState({
                cityOption: [{ label: "No Data", value: "No Data" }]
            })
        }

        let userDetail = JSON.parse(localStorage.getItem('userData'));
        if (localStorage.getItem('userLogin') === "true" && userDetail.userType !== "admin") {
            this.setState({
                signInSectionModel:false,
                sendResumeOption: false,
                userData: userDetail
            })
        }
        const { listStatus, resUmeUpload, resumeSectionModel } = this.state;
        if (nextProps.resumeSent && nextProps.resumeSent.statusCode === 200 && resumeSectionModel) {
            notification.success({
                message: "Resume Send Successfully",
                className:'successNotification',
                duration: 3
            });
            this.setState({
                fileName: "",
                resumeSectionModel: !resumeSectionModel,
                resUmeUpload: false,
                resumeNotSelect: false,
                requestServer: false,
            })
        }
           
        if (nextProps.resume && nextProps.resume.statusCode && nextProps.resume.statusCode === 200 && resUmeUpload) {
            this.setState({
                resUmeUpload: false
            })
            var reqResume = {
                providerType: "jobProvider",
                id: this.state.checkedValue,
                userEmail: this.state.userData.email,
                imageName: this.state.fileName,
                resumeImage: nextProps.resume.file_name
            }
            this.props.sendResumeAction(reqResume);
        }

        if (nextProps.listPost && Array.isArray(nextProps.listPost.data) && listStatus) {
            var list = this.state.list
            list = [];
            list = nextProps.listPost.data;
            this.setState({
                requestServer: false,
                listStatus: false,
                list: list,
                totalCount: nextProps.listPost.count
            })
        }

        if (nextProps.listPost && nextProps.listPost.statusCode === 500 && nextProps.listPost.status === "Error") {
            var listData = this.state.list
            listData = [];
            listData = nextProps.listPost.data;
            this.setState({
                requestServer: false,
                listStatus: false,
                list: listData,
                totalCount: nextProps.listPost.count
            })
        }

        if (nextProps && nextProps.fields && nextProps.fields.length > 0) {
            var fieldsList = nextProps.fields
            var option = []
            for (var i in nextProps.fields) {
                let obj = {
                    value: fieldsList[i]._id,
                    label: fieldsList[i].name
                }
                option.push(obj);
            }

            this.setState({
                fieldsList: nextProps.fields,
                fieldOption: option
            })

            if (this.state.reqObj && this.state.reqObj.fieldSelct) {
                var fieldSelct = this.state.reqObj.fieldSelct;
                let fieldOption = this.state.fieldOption
                let optionSelect = this.state.optionSelect
                for (var n in fieldSelct) {
                    var index = fieldOption.findIndex(p => p.value === [fieldSelct[n]])
                    if (index > -1) {
                        optionSelect.push(fieldOption[index])
                    }
                }
                this.setState({
                    optionSelect: optionSelect
                });
            }
        }
    }

    viewDetails = (data, name) => {
        this.props.history.push({
            pathname: this.props.auth.cityUrlFunction("/profile/"+data.userUrlLink),
            state: data
        });
        /*this.setState({
            detailsModal: !this.state.detailsModal,
            detailsData: data
        })*/
    }

    handleChangeSelect = async (name, value) => {
        this.setState({
            [name]: value
        });
        if (name === "citySeacrh" && value && value.label) {
            let cityData = this.state.cityData;
            let indexof = cityData.findIndex(cityType => cityType._id === value.value);
            if(indexof > -1){
                var coordinate = cityData[indexof].coordinates
                localStorage.setItem("locationCity", JSON.stringify(value));
                localStorage.setItem("defaultCity", (value.label));
                localStorage.setItem("coordinate", JSON.stringify(coordinate));

                this.setState({
                    citySeacrhCordinate: coordinate
                },function() {
                    this.suggeStionPost(10, 0, this.state.tagvalue)
                    this.props.history.push({
                        pathname: this.props.auth.cityUrlFunction("/search-result"),
                    });
                })
            }
        }
        // if (name === "countrySelect") {
        //     localStorage.setItem("locationCountry", JSON.stringify(value));
        //     localStorage.removeItem("locationCity");
        //     this.setState({
        //         citySeacrh: {"label": "All", value: "all"}
        //     })
        //     let cuntryReqObj = {
        //         countryName: value,
        //     }
        //     this.props.getAllCityByCountryAction(cuntryReqObj)
        // }
    }

    pageChange = (value, e) => {
        this.setState({
            activeButton: value,
            listStatus: true
        });
        this.suggeStionPost(10, (value - 1));
    }

    readMoreOption = (value, type, e) => {
        if (type === "right") {
            $('#text' + value).css('display', 'inline');
            $('#down' + value).css('display', 'block');
            $('#dots' + value).css('display', 'none');
            $('#right' + value).css('display', 'none');
        }
        if (type === "down") {
            $('#dots' + value).css('display', 'inline');
            $('#text' + value).css('display', 'none');
            $('#down' + value).css('display', 'none');
            $('#right' + value).css('display', 'inline-block');
        }
    }

    peginationButton(count) {
        peginationButton = []
        var countBtn = this.state.totalCount;
        countBtn = Math.ceil(countBtn / 10)
        for (var i = 0; i < countBtn; i++) {
            var peg = <PaginationItem onClick={this.pageChange.bind(this,i+1)}>
                          <PaginationLink href="#" className={(i+1)===this.state.activeButton?"pegBtnactive":"pegBtn"}>
                           {i+1}
                          </PaginationLink>
                        </PaginationItem>
            peginationButton.push(peg)
        }
    }

    fields() {
        fieldsArr = [];
        const { list } = this.state
        var i = 0;
        for (i in list) {
            var specializations = list[i].specializations;
            var text1 = list[i].shortBio;
            var text2 = "";
            var specliz = [];
            if (list[i].shortBio) {
                var sortBioLength = list[i].shortBio.length;
                if (sortBioLength > 280) {
                    text1 = list[i].shortBio.substr(0, 280);
                    if ((sortBioLength - 280) > 20) {
                        text2 = list[i].shortBio.substr(280, sortBioLength);
                    } else {
                        text1 = list[i].shortBio;
                    }
                }
            }
            if (specializations.length > 0) {
                specliz = [];
                for (var v in specializations) {
                    specliz.push(<span className="specilZationSerch-result" key={v}>{specializations[v]}</span>)
                }
            }
            carts[i] = "right"
            fieldsArr.push(
                <div className="result-content">
                    <div>
                        <div className="text1sec"> 
                            <input type="checkbox"  name="fields" id={list[i]._id} value={list[i]._id} onChange={this.handleChangeCheckBox} />
                            <label htmlFor={list[i]._id}></label>
                            <label className="notcheckkable" onClick={this.viewDetails.bind(this,list[i])} >{list[i].firstName}{list[i].lastName}</label>
                            <div className="company-desc">{text1}{text2!==""?<span><span id={"dots"+i}>...</span><span className="text2sec" id={"text"+i}>{text2}</span>
                                <span className="right-caret" onClick={this.readMoreOption.bind(this,i,"right")} id={"right"+i}>
                                   Read More
                                </span> 
                                <span className="down-caret" onClick={this.readMoreOption.bind(this,i,"down")} id={"down"+i}>
                                    Read less
                                </span></span>:''}
                                <div>{specliz}</div> 
                            </div>  
                        </div>
                    </div>
                </div>
            )
        }
    }

    // changeCity = (e) => {
    //     const { reqObj } = this.state
    //     e.preventDefault();
    //     reqObj["search"] = e.target.value;
    //     this.setState({
    //         reqObj: reqObj
    //     })
    // }

    handleChangeCheckBox = () => {
        var items = document.getElementsByName('fields');
        var allCheckBox = document.getElementsByName('allCheckBox');
        var allCheck = false;
        var allNotCheck = true;
        for (var i = 0; i < items.length; i++) {
            if (items[i].checked === true) {
                allCheck = true
            } else {
                allNotCheck = false
            }
        }
        if (allNotCheck && allCheck) {
            allCheckBox[0].checked = true;
        } else {
            allCheckBox[0].checked = false;
        }
    }

    allCheckBox = () => {
        var items = document.getElementsByName('fields');
        var allCheckBox = document.getElementsByName('allCheckBox');
        for (var i = 0; i < items.length; i++) {
            if (items[i].type === 'checkbox')
                items[i].checked = allCheckBox[0].checked;
        }
    }

    getValueCheckBox = () => {
        let checkedValue = []
        var items = document.getElementsByName('fields');
        for (var i = 0; i < items.length; i++) {
            if (items[i].checked === true) {
                checkedValue.push(items[i].value);
            }
        }
        return checkedValue;
    }

    handleDelete = (i) => {
        const { tags, tagvalue } = this.state;
        this.setState({
            tags: tags.filter((tag, index) => index !== i),
            tagvalue: tagvalue.filter((tagvalue, index) => index !== i),
        });
    }

    handleDrag = (tag, currPos, newPos) => {
        const tags = [...this.state.tags];
        const newTags = tags.slice();
        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);
        this.setState({ tags: newTags });
    }

    handleAddition = (tag) => {
        var tagvalue = tag.text;
        this.setState(state => ({ tags: [...state.tags, tag] }));
        this.setState(state => ({ tagvalue: [...state.tagvalue, tagvalue] }));
        this.suggeStionPost(10, 0, tagvalue);
    }

    sendResume = (e) => {
        var checkValue = this.getValueCheckBox();
        if (checkValue.length > 0) {
            this.setState({
                checkedValue: checkValue,
                resumeSectionModel: !this.state.resumeSectionModel
            })
        } else {
            notification.error({
                message: "Please Select CheckBox",
                className:'errorNotification',
                duration: 3
            });
        }
    }

    resumeUpload = (e) => {
        this.setState({
            fileName: "",
            resumeSendFor: "",
            resumeSectionModel: !this.state.resumeSectionModel
        })
    }

    signInModel = (e) => {
        this.setState({
            signInSectionModel: !this.state.signInSectionModel
        })
    }

    sendResumeTo = (e) => {
        if (this.state.selectResumeType === "profile") {
            if (this.state.resumeSendFor !== "") {
                var reqResume = {
                    providerType: "jobProvider",
                    id: this.state.checkedValue,
                    userEmail: this.state.userData.email,
                    resumeImage: this.state.resumeSendFor
                }
                this.props.sendResumeAction(reqResume);

            } else {
                this.setState({
                    resumeNotSelect: true
                })
            }
        } else {
            e.preventDefault();
            var file = document.getElementById("file").files[0];
            this.setState({
                resUmeUpload: true,
            })
            this.props.uploadResumeFile(file)
        }
    }

    emailInput = e => {
        e.preventDefault();
        this.setState({
            emailId: e.target.value
        })
    }

    fileSelect = (e) => {
        e.preventDefault();
        var file = document.getElementById("file").files[0];
        this.setState({
            fileName: file.name
        })
    }

    onChangeForSlctResume = (e) => {
        this.setState({
            resumeSendFor: e.target.value,
            resumeNotSelect: false
        })
    }

    handleChangeTypeResume = (e) => {
        let selectResumeType = this.state.selectResumeType
        selectResumeType = e.target.value
        if (selectResumeType === "profile") {
            if (this.state.userData && this.state.userData.resume && this.state.userData.resume !== "") {
                this.setState({
                    selectResumeType: selectResumeType,
                });
            } else {
                notification.error({
                    message: "Please Uplode resume in Profile",
                    className:'errorNotification',
                    duration: 3
                });
            }
        } else {
            this.setState({
                selectResumeType: selectResumeType,
            });
        }
    }

    searchTextFillter = (e) => {
        e.preventDefault();
        const { activeButton } = this.state
        var reqObj = this.state.reqObj;
        reqObj.search = e.target.value;
        this.setState({
            reqObj: reqObj
        })
        this.suggeStionPost(10, (activeButton - 1));
    }

    searchBox = (e) => {
        e.preventDefault();
        var reqObj = this.state.reqObj;
        reqObj.search = e.target.value;
        this.setState({
            reqObj: reqObj
        })
    }

    handleChangeradioForRadio = (value, e) => {
        let userDetail = JSON.parse(localStorage.getItem('userData'));
        if (value !== "showAll" && (!localStorage.getItem('userLogin') && !userDetail)) {
            this.signInModel();
        } else {
            this.setState({
                showRecords: value
            },function (){
             this.suggeStionPost(10, 0, this.state.tagvalue)   
            })
        }    
    }

    pagePrvBack(value,a){
        let btn = 0;
        if(value === "prv"){
            btn = this.state.activeButton -1;
        }
        if(value === "next"){
            btn = this.state.activeButton +1;
        }
        let countBtn = this.state.totalCount;
        countBtn = Math.ceil(countBtn / 10)
        if(btn && (btn <= countBtn ? true:false)){
            this.setState({
                activeButton: btn,
                listStatus: true
            });
            this.suggeStionPost(10, (btn-1));
        }
    }
    signIn = () => {
        this.props.history.push({
            pathname: "/sign-in",
            state: { "fieldSelct": this.state.fieldSelct }
        });
    }

    render() {
        const meta = {
            title: 'Right Connection | Recruiter Candidate Network',
            description: 'arightconnection is just a simple way a job seeker can connect to recruiters be it individual recruiters or company recruiters. A user can register as a job seeker or recruiter. We also differentiate them as them recruiting for their own organisation (company) or someone recruiting for multiple companies.',
            canonical: '<link rel="canonical" href=" https://arightconnection.com/LosAngeles " data-rdm="">',
            meta: {
                charset: 'utf-8',
                name: {
                    keywords: 'react,meta,document,html,tags'
                }
            }
        };
        this.peginationButton();
        this.fields();
        const { resumeNotSelect, requestServer, resumeSendFor, reqObj, fieldOption, fileName, detailsData, sendResumeOption, selectResumeType, countryOption, showRecords } = this.state;
        let resumeArr = this.state.userData && this.state.userData.resume ? this.state.userData.resume : [];

        if (requestServer) {
            className = "pageloading";
        } else {
            className = "";
        }
        var workingCity = [];
        var categeoryName = [];
        var speciality = [];


        if (Array.isArray(detailsData.companyAddress)) {
            for (var z in detailsData.companyAddress) {
                workingCity.push(<div className="tub">{detailsData.companyAddress[z].city}</div>)
            }
        }

        if (Array.isArray(detailsData.specializations)) {
            for (var y in detailsData.specializations) {
                speciality.push(<div className="tub">{detailsData.specializations[y]}</div>)
            }
        }

        if (Array.isArray(detailsData.categoryId)) {
            for (var x in detailsData.categoryId) {
                var index = fieldOption.findIndex(p => p.value === [detailsData.categoryId[x]])
                if (index === -1) {
                    categeoryName.push(<div className="tub">{fieldOption[x].label}</div>);

                }
            }
        }

        return (
            <div className="search-page">
                <div className="home-wrapper">
                    <DocumentMeta {...meta}>
                        <title>Search Result</title>
                        <meta name="description" content="Some description." />
                        <meta property="og:title" content="MyApp" />
                        <meta property="og:image" content="path/to/image.jpg" />
                    </DocumentMeta>
                    <div className={"pageForLoading "+className}>
                        <div className=" wrap">
                            <div className="loading">
                                <img src={loadingImage} alt="Loading" />
                            </div>
                        </div>
                    </div>
                    <Header props={ this.props } />
                    <div className="page-wrapper">
                        <div className="container">
                            <div className="row flx-po">
                                <div className="col-md-6 custom-field">
                                    <div className="input-border top-b">
                                        <input type="text" className="form-control serach-Box" id="globalSearch" value={reqObj&&reqObj.search==="all" ?"":reqObj.search} placeholder="Search" onChange={this.searchTextFillter.bind(this)} />
                                        <a className="search-btn" onClick={this.searchTextFillter}>{/*<span className="f-text">Search</span>*/} <i className="fa fa-search"></i></a>
                                    </div>
                                </div>
                               {/* <div className="col-md-3">
                                    <Select name="countrySelect" className="singup-control borderd-r" value={this.state.countrySelect} onChange={this.handleChangeSelect.bind(this, "countrySelect" )} options={countryOption} placeholder="Select Country" />
                                </div>*/}
                                <div className="col-md-3">
                                    <Select name="citySeacrh" className="singup-control borderd-r" value={this.state.citySeacrh} onChange={this.handleChangeSelect.bind(this, "citySeacrh" )} options={this.state.cityOption} placeholder="Select City" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-sm-12">
                                    <div className="check">
                                        <div className="custom-control custom-radio custom-control-inline">
                                            <input type="radio" className="custom-control-input" id="defaultInline1" name="fillterBtn" onChange={this.handleChangeradioForRadio.bind(this,"showAll")} checked={showRecords==="showAll" ?true:false} />
                                            <label className="custom-control-label radio-text " htmlFor="defaultInline1">Show All</label>
                                        </div>
                                        <div className="custom-control custom-radio custom-control-inline">
                                            <input type="radio" className="custom-control-input" id="defaultInline2" name="fillterBtn" onChange={this.handleChangeradioForRadio.bind(this,"last30Days")} checked={showRecords==="last30Days" ?true:false} />
                                            <label className="custom-control-label radio-text " htmlFor="defaultInline2">Not Contacted in last 30 days</label>
                                        </div>
                                        <div className="custom-control custom-radio custom-control-inline">
                                            <input type="radio" className="custom-control-input" id="defaultInline3" name="fillterBtn" onChange={this.handleChangeradioForRadio.bind(this,"neverContected")} checked={showRecords==="neverContected" ?true:false} />
                                            <label className="custom-control-label radio-text " htmlFor="defaultInline3">Never Contacted</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="search-result-block">
                                <div className="row">
                                    <div className="col-md-12 col-sm-12">
                                        {fieldsArr.length >0 &&
                                        <div className="chk-all-block result-content">
                                            <input type="checkbox" className="all-chk-box" name="allCheckBox" id="select-all" onClick={this.allCheckBox} />
                                            <label htmlFor="select-all"></label>
                                            <label className="select-box notcheckkable">Select All</label>
                                        </div>
                                        }
                                        {fieldsArr}
                                    </div>
                                </div>
                                {fieldsArr.length===0&&
                                <span>No data found with these selection</span>
                                }
                            </div>
                            <div className="pagination-block">
                                <div className="row">
                                    {peginationButton.length>1&&
                                    <div className="col-md-12">
                                        <Pagination aria-label="Page navigation example">
                                            <PaginationItem  onClick={this.pagePrvBack.bind(this,'prv')} disabled={this.state.activeButton == 1 ? true :false}>
                                                Prev
                                            </PaginationItem>
                                            {peginationButton}
                                            <PaginationItem onClick={this.pagePrvBack.bind(this,'next')} disabled= {this.state.activeButton*10 >= this.state.totalCount ? true:false}>
                                                Next
                                            </PaginationItem>
                                        </Pagination>
                                    </div>
                                    }
                                </div>
                            </div>
                            <div className="button-block">
                                <div className="row">
                                    <div className="col-md-8">
                                        {fieldsArr.length >0 &&
                                        <Button className="btn mrgn resume-btn" onClick={this.sendResume}>Send Resume</Button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                    <Modal backdrop="static" keyboard={false} isOpen={this.state.resumeSectionModel} toggle={this.resumeUpload} className={this.props.className}>
                        <ModalHeader toggle={this.resumeUpload}>Send Resume</ModalHeader>
                        <ModalBody className="spc-radi">
                            {sendResumeOption&&
                            <span>
                                <div className="modal-wrap">
                                    <div className="warn-text">{message.sendResumeWithoutSignin}</div>
                                    <div className="signinPopup">
                                        <CustomLinkedIN textTtile={"Sign in with LinkedIn"} props={ this.props } />
                                        <button className="btn btn-signIn drop-Signin" title="Sign In" onClick={this.signIn}><i className="fa fa-sign-in"></i> Sign-In</button>&nbsp;
                                    </div>
                                </div>
                            </span>
                            }
                            {!sendResumeOption&&
                            <div className="row mnge-spce">
                                <div className="col-md-12 ">
                                    <label>Select saved resume</label>
                                    <input type="radio" name="selectResume" id="profile" className="" value="profile" checked={selectResumeType==="profile" } onChange={this.handleChangeTypeResume} />
                                </div>
                                <div className="col-md-12">
                                    <label>Upload new resume</label>
                                    <input type="radio" name="selectResume" id="upload" className="" value="upload" checked={selectResumeType==="upload" } onChange={this.handleChangeTypeResume} />
                                </div>
                            </div>
                            }
                            {!sendResumeOption&&
                            <div>
                                {selectResumeType === "upload" &&
                                <form onSubmit={this.sendResumeTo} validate>
                                    <div className="row">
                                        {/* <div className="col-md-12">
                                            <label>Email<span className="requiredField">*</span></label><br />
                                            <input type="email" className="input-field-control" placeholder="email" name="email" id="userEmail" value={this.state.emailId} onChange={this.emailInput} required />
                                        </div>*/}
                                        <div className="col-md-12">
                                            <div className="box">
                                                <h5 className="upload-label">Upload Resume</h5>
                                                <div className="upload-icon"><i className="fa fa-upload"></i></div>
                                                <input type="file" className="box__file" name="files" id="file" onChange={this.fileSelect.bind(this)} accept=".xlsx,.xls,.doc,.docx,.ppt, .pptx,.txt,.pdf" required />
                                                <div className="uploaded-file-name">{fileName}</div>
                                                <label htmlFor="file"><strong>Choose a file</strong><span className="box__dragndrop"> or drag it here</span>.</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-btn-block">
                                        <Button type="submit" className="btn modal-save-btn" disabled={sendResumeOption}>Submit</Button>
                                        <a type="cancel" className="btn modal-cancel-btn" onClick={this.resumeUpload}>Cancel</a>
                                    </div>
                                </form>
                                }
                                {/* <input type="radio" className="radio-multiple" name="resumeSendFor" id="key" value="96a2253d-f1ca-499e-8076-54c2859adf92.docx" checked={resumeSendFor==="96a2253d-f1ca-499e-8076-54c2859adf92.docx" } />*/}
                                <div className="remob-p">
                                    {selectResumeType==="profile" &&
                                    resumeArr.map((resume,index)=>(
                                    <div className="spc-manage-com">
                                        <input type="radio" className="radio-multiple" name="resumeSendFor" id={resume._id} value={resume.resumeImage} checked={resumeSendFor===resume.resumeImage?true:false} onChange={((e)=>this.onChangeForSlctResume(e))} />
                                        <span className="pf-label border-sqr spcf-comp">
                                            <a href={process.env.REACT_APP_SERVER_IMAGE_BUCKET+"/"+resume.resumeImage}>{resume.name}</a>
                                            {/* <a onClick={this.fileDownLoads(process.env.REACT_APP_SERVER_IMAGE_BUCKET+"/"+resume.resumeImage,resume.name)}>{resume.name}</a> */}
                                        </span>
                                    </div>
                                    ))
                                    }
                                    {resumeNotSelect&&
                                    <span>Please Select Resume</span>
                                    }
                                </div>
                                {selectResumeType === "profile" &&
                                <div className="col-md-12 btnfinfcomp">
                                    <Button type="submit" className="btn modal-save-btn" onClick={this.sendResumeTo} disabled={sendResumeOption}>Submit</Button>
                                    <a type="cancel" className="btn modal-cancel-btn" onClick={this.resumeUpload}>Cancel</a>
                                </div>
                                }
                            </div>
                            }
                        </ModalBody>
                    </Modal>                    

                    <Modal backdrop="static" keyboard={false} isOpen={this.state.signInSectionModel} toggle={this.signInModel} className={this.props.className}>
                        <ModalHeader toggle={this.signInModel}>Please Sign In</ModalHeader>
                        <ModalBody className="spc-radi">
                            {sendResumeOption&&
                            <span>
                                <div className="modal-wrap">
                                    <div className="warn-text">{message.sendResumeWithoutSignin}</div>
                                    <CustomLinkedIN textTtile={"Sign in with LinkedIn"} props={ this.props } />
                                    <button className="btn btn-signIn drop-Signin" title="Sign In" onClick={this.signIn}><i className="fa fa-sign-in"></i> Sign-In</button>&nbsp;
                                </div>
                            </span>
                            }
                        </ModalBody>
                    </Modal>
                    
                    <Modal backdrop="static" keyboard={false} isOpen={this.state.detailsModal} toggle={this.viewDetails} className="detail-modal modal-lg">
                        <ModalBody>
                            <div className="profile-head box-design">
                                <div className="img-circular">
                                    <img src={detailsData.image?this.props.auth.showImage(detailsData.image):"https://images.pexels.com/photos/20787/pexels-photo.jpg?auto=compress&cs=tinysrgb&h=350"} alt="new" className="rounded" scale={4} vertical={0} horizontal={5} />
                                </div>
                                <div className="company-name">
                                    {detailsData.firstName}
                                </div>
                                <div className="close-box">
                                    <a href="#" className="close" onClick={this.viewDetails} data-dismiss="modal" aria-label="close">&times;</a>
                                </div>
                            </div>
                            <div className="profile-content">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="detail-left">
                                            <div className="block-1">
                                                <div className="cat-label">City</div>
                                                <div className="cat-name">{workingCity}</div>
                                            </div>
                                            <div className="block-1">
                                                <div className="cat-label">Category</div>
                                                <div className="cat-name">{categeoryName}</div>
                                            </div>
                                            <div className="block-1">
                                                <div className="cat-label">Speciality</div>
                                                <div className="cat-name">{speciality}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="detail-right">
                                            <div className="block-1">
                                                <div className="cat-label">ShortBio</div>
                                                <div className="cat-name">{detailsData.shortBio}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ModalBody>
                        <div className="modal-btn-block">
                            <a type="cancel" className="btn modal-cancel-btn" onClick={this.viewDetails}>Close</a>
                        </div>
                    </Modal>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        allCitySuggetion: state.FindRecCompany.allCitySuggetion,
        responseCityByCountry: state.FindRecCompany && state.FindRecCompany.responseCityByCountry,
        responseCountry: state.FindRecCompany && state.FindRecCompany.responseCountry,
        fields: state.home.response.data,
        listPost: state.FindRecCompany.response && state.FindRecCompany.response.data ? state.FindRecCompany.response.data : [],
        resume: state.FindRecCompany.resume,
        city: state.FindRecCompany.city,
        resumeSent: state.SendResume.response
    };
}

export default withRouter(connect(mapStateToProps, {
    getAllSugeetionByField,
    getAllHome,
    uploadResumeFile,
    sendResumeAction,
    reqUestDeniedByCity,
    listCityCountryStateAction,
    getAllCountryAction,
    getAllCityAction,
    getAllCityByCountryAction
})(SearchResult));


// WEBPACK FOOTER //
// ./src/components/Search/FindCompany.js